module.exports = __webpack_public_path__ + "img/zimg3.5c5740f3.png";